import { Dialog } from '@mui/material'
import { User, RetailerAccount } from '@promoboxx/graphql-gateway-types'
import { useSelector } from 'react-redux'

import { selectors } from '@src/stores'

import {
  FacebookPermissionsManager,
  FacebookPermissionsManageronCloseProps,
} from './FacebookPermissionsManager'

interface FacebookPermissionsDialogProps {
  open: boolean
  handleClose: (
    FacebookPages: FacebookPermissionsManageronCloseProps['facebookPages'],
  ) => void
  initialFacebookPageId?: string | null
}

export function FacebookPermissionsDialog({
  open,
  handleClose,
  initialFacebookPageId,
}: FacebookPermissionsDialogProps) {
  const onClose = (
    props?: FacebookPermissionsManageronCloseProps | undefined,
  ) => {
    handleClose && handleClose(props?.facebookPages || [])
  }

  const user: User = useSelector(selectors.auth.userSelector)
  const retailerAccount: RetailerAccount = useSelector(
    selectors.app.currentRetailerAccountSelector,
  )
  return (
    <Dialog
      fullWidth={true}
      maxWidth={'md'}
      onClose={() => onClose()}
      open={open}
    >
      <FacebookPermissionsManager
        onClose={onClose}
        retailerAccount={retailerAccount}
        user={user}
        initialFacebookPageId={initialFacebookPageId}
      />
    </Dialog>
  )
}
